import { render, staticRenderFns } from "./goodsAcount.vue?vue&type=template&id=b3f8fc80&scoped=true&"
import script from "./goodsAcount.vue?vue&type=script&lang=js&"
export * from "./goodsAcount.vue?vue&type=script&lang=js&"
import style0 from "./goodsAcount.vue?vue&type=style&index=0&id=b3f8fc80&lang=less&scoped=true&"
import style1 from "./goodsAcount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f8fc80",
  null
  
)

export default component.exports